import {observer} from "mobx-react";
import * as React from "react";
import {TableViewV5} from "../../../abstract/TableViewV5";
import {XyiconFeature} from "../../../../../generated/api/base";
import type {PortfolioGroup} from "../../../../../data/models/PortfolioGroup";
import type {IActionBarItem} from "../../../abstract/ModuleViewV5";
import DeleteIcon from "../../../icons/delete.svg?react";
import {Functions} from "../../../../../utils/function/Functions";
import {PortfolioGroupDetailsContentV5} from "./PortfolioGroupDetailsContentV5";
import {CreatePortfolioGroupPanelV5} from "./CreatePortfolioGroupPanelV5";

@observer
export class PortfolioGroupsViewV5 extends React.Component {
	private _headers = [
		{
			id: "name",
			title: "Group Name",
		},
		{
			id: "portfolioIds",
			title: "Number of portfolios",
		},
		{
			id: "lastModifiedAt",
			title: "Last Updated",
		},
		{
			id: "lastModifiedBy",
			title: "Updated By",
		},
	];

	private canDeletePortfolioGroups = (portfolioGroups: PortfolioGroup[]) => {
		if (portfolioGroups.length < 1) {
			return false;
		}

		return true;
	};

	private getActionBar = () => {
		const result: IActionBarItem<PortfolioGroup>[] = [
			{
				id: "delete",
				title: "Delete Report",
				label: "Delete",
				IconComponent: DeleteIcon,
				isVisible: Functions.returnTrue,
				isEnabled: this.canDeletePortfolioGroups,
			},
		];

		return result;
	};

	public override render() {
		return (
			<TableViewV5
				feature={XyiconFeature.PortfolioGroup}
				headers={this._headers}
				create={(onCreated, onCancel, creating) => (
					<CreatePortfolioGroupPanelV5
						onCreated={onCreated}
						creating={creating}
					/>
				)}
				details={(selected: PortfolioGroup[]) => <PortfolioGroupDetailsContentV5 portfolioGroups={selected} />}
				actionBar={this.getActionBar()}
			/>
		);
	}
}
